//CRN_20260508 - Riskline Travel Search v2 service (PULL via SureSim backend proxy)
//CRN_20260513 - https://riskline.readme.io/reference/apis-overview

import { catchError, Observable, of, throwError } from 'rxjs';
import { eSimApiPaths } from '../../consts';
import { environment } from 'src/environments/environment';
import { ExceptionsService } from '../utelize/general/exceptions-service';
import { HttpClientService } from '../utelize/general/http-client-service';
import { Injectable } from '@angular/core';
import { TravelSearchRequestDTO, TravelSearchResponseDTO } from '../../models/system/riskline/riskline-travel-search.dto';

@Injectable({ providedIn: 'root' })
export class RisklineTravelSearchService {

  constructor(
    private exceptionsService: ExceptionsService,
    private httpClientService: HttpClientService
  ) { }

  public search(request: TravelSearchRequestDTO): Observable<TravelSearchResponseDTO> {
    try {
      return this.httpClientService
             ._post<TravelSearchResponseDTO>(environment.eSimApi +
                                             eSimApiPaths.RiskIntelligence + '/' +
                                             eSimApiPaths.RiskIntelligenceTravelSearch,
                                             request)
             .pipe(
               catchError((error) => {
                 return throwError(() => new Error('RisklineTravelSearchService.search() - ' + this.exceptionsService.formatHttpError(error)));
               })
             );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }
}
